import {SimpleTable} from "../../common/simpleTable/SimpleTable.jsx";
import {listaTagowColumns} from "./lib/columns/listaTagowColumns.js";
import ButtonWithIcon from "../../common/ButtonWithIcon.jsx";
import {Icons} from "../../common/Icons.jsx";
import {useState} from "react";
import {HeaderTitle} from "../../common/HeaderTitle.jsx";
import {ModalDodajEdytujTagi, ModalUsunTag} from "./lib/modals.jsx";
import {useTagiFull} from "../../../api/domain/tagi/queries/useTagiFull.jsx";

const ViewTagiList = () => {

    const tagi = useTagiFull();
    const [currPozycja, setCurrPozycja] = useState(null)
    const [modalState, setModalState] = useState({
        dodajEdytuj: false,
        usun: false,

    })


    const modals = () => <>
        <ModalDodajEdytujTagi
            show={modalState.dodajEdytuj}
            handleClose={() => setModalState(prev => ({...prev, dodajEdytuj: false}))}
            currPozycja={currPozycja}
        />

        <ModalUsunTag
            show={modalState.usun}
            handleClose={() => setModalState(prev => ({...prev, usun: false}))}
            currPozycja={currPozycja}
        />

    </>


    const handleAddEdit = (row, mode = 'dodaj') => {
        setCurrPozycja(mode === 'dodaj' ? null : row)
        setModalState(prev => ({...prev, dodajEdytuj: true}))
    }


    const handleUsun = (row) => {
        setCurrPozycja(row)
        setModalState(prev => ({...prev, usun: true}))

    }

    const td = (row) => {
        return <td>
            <div className={'d-flex gap-1'}>
                <ButtonWithIcon
                    title={'Edytuj'}
                    icon={<Icons.edit/>}
                    onClick={() => handleAddEdit(row, 'edycja')}
                />

                <ButtonWithIcon icon={<Icons.delete/>}
                                title={'Usuń'}
                                variant={'danger'}
                                onClick={() => handleUsun(row)}
                />


            </div>
        </td>
    }
    return (
        <>
            {modals()}
            <HeaderTitle
                title={'Lista tagów'}
                size={'h2'}
                nav
                destination={'/'}
            />

            <div className={'d-flex justify-content-end gap-3'}>
                <>
                    <ButtonWithIcon
                        text={'Dodaj nową kategorię / tag'}
                        variant={'primary'}
                        icon={<Icons.add/>}
                        onClick={() => handleAddEdit(null, 'dodaj')}
                        title='Dodaj nowy tag'/>


                </>

            </div>

            <SimpleTable
                data={tagi.data}
                addTh={() => <th>Operacje</th>}
                addTd={td}
                columns={listaTagowColumns}
            />
        </>
    )
}

export default ViewTagiList